import { ItemVariant } from "./ItemVariant";

export const useResolveVariant = (variant?: ItemVariant): ItemVariant => {
  return variant ?? "square";
};
